import { useRouteError } from "react-router-dom";
import Card from "./components/elements/Card";

export default function ErrorPage() {
  const error = useRouteError();

  return (
    <div className="m-5">
      <Card>
        <h1>An error occurred</h1>
        <p>{error.statusText || error.message}</p>
      </Card>
    </div>
  );
}
